// @ts-nocheck
import { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { RadioComponentProps } from "@insite/mobius/Radio";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import FieldSetPresentationProps from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface MessagesProps {
    centeringWrapper?: InjectableCss;
    messagesSection?: InjectableCss;
    messagesAccordion?: AccordionPresentationProps;
    messagesAccordionSection?: AccordionSectionPresentationProps;
    messagesGridContainer?: GridContainerProps;
    messageFilterGridItem?: GridItemProps;
    messageFilter?: MessageFilterStyles;
    messageCardGridItem?: GridItemProps;
    messageCard?: MessageCardStyles;
    noMessagesGridItem?: GridItemProps;
    noMessagesText?: TypographyPresentationProps;
    loadingOverlay?: LoadingOverlayProps;
}

interface MessageFilterStyles {
    radioGroup?: RadioGroupProps;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
}

interface MessageCardStyles {
    article?: InjectableCss;
    gridContainer?: GridContainerProps;
    dateTimeGridItem?: GridItemProps;
    dateTimeText?: TypographyProps;
    subjectGridItem?: GridItemProps;
    subjectText?: TypographyProps;
    bodyGridItem?: GridItemProps;
    bodyText?: TypographyProps;
    actionButtonGridItem?: GridItemProps;
    actionButton?: ButtonPresentationProps;
    bottomBorderGridItem?: GridItemProps;
    bottomBorder?: InjectableCss;
    heading?: HeadingPresentationProps;
    actionLink?: LinkPresentationProps;
}

export const messagesProps: MessagesProps = {
    noMessagesText: typographyGetNoResultsProps(),
    messageCard: {
        article: {
            css: css`
                ${boxStyles(pxToRemArray([25]))}
                ${spacingStyles()}
            `,
        },
        heading: {
            forwardAs: "h3",
            verticalAlign: "top",
            extendedStyles: {
                title: {
                    css: css`
                        ${spacingStyles(null, pxToRem(10))}
                        padding-bottom: ${pxToRem(10)};
                        border-bottom: 1px solid ${getColor("common.border")};

                        ${({ theme }) => css`
                            font-weight: ${theme.design.typography.weight.bold};
                            line-height: ${theme.design.typography.lineHeight.semi};
                        `}
                    `,
                },
                flexWrapper: {
                    verticalGap: pxToRem(2),
                    extendedStyles: {
                        content: {
                            css: css`
                                ${breakpoint("sm")} {
                                    flex-wrap: nowrap;
                                }
                            `,
                        },
                        item: {
                            css: css`
                                &:nth-child(2) {
                                    white-space: nowrap;

                                    ${breakpoint("xs", "down")} {
                                        width: 100%;
                                    }
                                }
                            `,
                        },
                    },
                },
            },
        },
        dateTimeText: {
            css: css`
                color: ${getColor("text.accent")};
                font-size: ${x => x.theme.design.typography.size.smallest};
                font-style: italic;
            `,
        },
        bodyText: {
            forwardAs: "p",
            css: css`
                ${spacingStyles(null, pxToRem(8))}
                color: ${getColor("text.accent")};
                font-size: ${x => x.theme.design.typography.size.small};
            `,
        },
        actionLink: {
            css: css`
                ${linkActionStyles()}
                display: flex;
            `,
        },
    },
};
